import * as base from './base'

export function DATETIME (row, column, value, index) {
  return base.formatDateTime(value, 'yyyy-MM-dd HH:mm:ss')
}

export function BOOL (row, column, value, index) {
  return base.dictText('BOOL', value)
}